import React from "react";

export const HospitalIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.705"
      height="19.705"
      viewBox="0 0 19.705 19.705"
    >
      <g
        id="hospital_icon"
        data-name="hospital icon"
        transform="translate(-58 -268)"
      >
        <g id="hospital" transform="translate(58 268)">
          <path
            id="Path_224488"
            data-name="Path 224488"
            d="M4.493,23.7H23.212a.493.493,0,0,0,.493-.493V11.389a.493.493,0,0,0-.493-.493H20.749V6.463a.493.493,0,0,0-.493-.493H17.793V5.478A1.478,1.478,0,0,0,16.315,4H11.389A1.478,1.478,0,0,0,9.911,5.478V5.97H7.448a.493.493,0,0,0-.493.493V10.9H4.493A.493.493,0,0,0,4,11.389V23.212A.493.493,0,0,0,4.493,23.7ZM20.749,11.882h1.97V22.719h-1.97ZM15.33,22.719H12.374V19.271H15.33ZM10.9,5.478a.493.493,0,0,1,.493-.493h4.926a.493.493,0,0,1,.493.493V10.4a.493.493,0,0,1-.493.493H11.389A.493.493,0,0,1,10.9,10.4ZM7.941,6.956h1.97V10.4a1.478,1.478,0,0,0,1.478,1.478h4.926A1.478,1.478,0,0,0,17.793,10.4V6.956h1.97V22.719H16.315V18.778a.493.493,0,0,0-.493-.493H11.882a.493.493,0,0,0-.493.493v3.941H7.941ZM4.985,11.882h1.97V22.719H4.985Z"
            transform="translate(-4 -4)"
            fill="#2e2e2e"
          />
          <path
            id="Path_224489"
            data-name="Path 224489"
            d="M20.493,10.463h.985v.985a.493.493,0,1,0,.985,0v-.985h.985a.493.493,0,1,0,0-.985h-.985V8.493a.493.493,0,1,0-.985,0v.985h-.985a.493.493,0,1,0,0,.985Z"
            transform="translate(-12.118 -6.03)"
            fill="#2e2e2e"
          />
        </g>
      </g>
    </svg>
  );
};
